import React, {useEffect, useState} from 'react';
import axios from "axios";
import CaseUserStatus from "../../../enums/CaseUserStatus";
import {FaArrowDown, FaArrowUp} from "react-icons/fa";
import {jwtDecode} from "jwt-decode";
import "./AdminCaseUserEdit.css";
import {TiFlowSwitch} from "react-icons/ti";
import {Tooltip} from "@mui/material";
import {IoPersonRemoveSharp} from "react-icons/io5";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import {AiOutlineUserSwitch} from "react-icons/ai";
import ChangeCaseUserPopup from "../../../components/CaseInsideTable/changeCaseUserPopup";
import {useLocation} from "react-router-dom";
import AddressingPopupAdmin from "../addressingpopup/AddressingPopupAdmin";

const AdminCaseUserEdit = () => {
    const [caseManagers, setCaseManagers] = useState([]);
    const [users, setUsers] = useState([]);
    const [roleId, setRoleId] = useState(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [currentFileCaseUserId, setCurrentFileCaseUserId] = useState(null);
    const [caseUserDeleteModalOpen, setCaseUserDeleteModalOpen] = useState(false);
    const [caseFiles, setCaseFiles] = useState([]);
    const [openChangeCaseUserPopup, setOpenChangeCaseUserPopup] = useState(false);
    const [managerToEdit, setManagerToEdit] = useState(null);
    const [caseData, setCaseData] = useState(null);
    const [departmentID, setDepartmentID] = useState(null);
    const location = useLocation();
    const [hasExpertResult, setHasExpertResult] = useState(false);

    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`${baseURL}/GetPermitTypeByID?Id=${caseData.permitTypeId}`);
            setDepartmentID(response.data.data.departmentId)

        } catch (error) {
        }
    };
    useEffect(() => {
        if (caseData) {
            void fetchPermitType();
        }
    }, [caseData]);





    const hasExpert = async () => {
        const experts = users.filter(user => user.roleName === "Expert");

        return experts.some(expert =>
            caseManagers.some(manager => manager.toUserId === expert.id)
        )

    }

    useEffect(() => {
        const checkIfHasExpert = async () => {
            const result = await hasExpert();
            setHasExpertResult(result);
        };
        void checkIfHasExpert();
    }, [users, caseManagers]);

    const fetchCaseData = async () => {
        const queryParams = new URLSearchParams(location.search);
        const caseId = queryParams.get("id");

        const endpoint = `${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`;

        try {
            const response = await axios.get(endpoint);
            const data = response.data;
            if (data && data.success) {
                setCaseData(data.data);

            } else {
            }
        } catch (error) {
        } finally {
        }
    };

    useEffect(() => {
        void fetchCaseData()
    }, []);

    const refreshCaseFiles = () => {
        void fetchCaseFiles();
    };
    const handleCloseCaseUserPopup = () => {
        setOpenChangeCaseUserPopup(false);
    };
    const handleClickOpenCaseUserPopup = () => {
        setOpenChangeCaseUserPopup(true);
    };


    useEffect(() => {
        void fetchCaseFiles()
    }, []);

    const fetchCaseFiles = async () => {
        try {

            const id = new URLSearchParams(window.location.search).get("id");


            const endpoint = `${baseURL}/GetAllCaseSharedFileByCaseID?CaseId=${id}`;

            const response = await axios.get(endpoint);

            let data;
            if (roleId === 'USER') {
                data = response.data.data;
            } else {
                data = response.data.data.resultItems;
            }

            if (Array.isArray(data)) {
                const reversedData = data.reverse();
                setCaseFiles(reversedData);
            } else {
            }
        } catch (error) {
        } finally {
        }
    };

    const handleDeleteCaseUser = async () => {
        const payload = {id: currentFileCaseUserId.id}
        const deletedUser = users.find(user => user.id === currentFileCaseUserId.toUserId)
        try {
            const response = await axios.post(`${baseURL}/DeleteCaseUser`, payload);
            if (response.status === 200 && response.data.success) {
                let toUserId = null;
                const filesToUpdate = caseFiles.filter(file => file.creatorId === currentFileCaseUserId.toUserId)

                if (deletedUser.roleName.toLowerCase() === "expert") {
                    const expertDepartment = fetchUserDetails(currentFileCaseUserId.toUserId)
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFDEPARTMENT".toLowerCase() && user.departmentId === expertDepartment.departmentId)
                    toUserId = toUserIdList[0]
                }
                if (deletedUser.roleName.toLowerCase() === "headofdepartment") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "DEPUTYHEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (deletedUser.roleName.toLowerCase() === "deputyheadofagency") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (deletedUser.roleName.toLowerCase() === "headofagency") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (filesToUpdate.length > 0 && toUserId) {
                    const updatePayload = {
                        casefileIds: filesToUpdate.map(file => file.id),
                        caseCreatorId: toUserId.id
                    };
                    await axios.put(`${baseURL}/UpdateCaseFileCreatorId`, updatePayload);
                }

                await fetchCaseManagersData()
                setCaseUserDeleteModalOpen(false)
            }

        } catch (error) {
            console.error(error)
        }
    };

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetAllInternalUsers`);
            const sortedUsers = response.data.data.result.sort((a, b) => {
                return a.firstName.localeCompare(b.firstName);
            });

            setUsers(sortedUsers);
        } catch (error) {
        }
    };

    const refreshCaseManagers = () => {
        void fetchCaseManagersData();
    };

    useEffect(() => {
        void fetchUsers()
    }, []);

    const fetchUserDetails = (userId) => {
        try {
            return users.find(user => user.id === userId);
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
            }
        }
    }, []);


    const fetchCaseManagersData = async () => {
        if (roleId !== "USER" && roleId !== null && users.length > 0) {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const caseIDFromURL = urlParams.get("id");
                const response = await axios.get(`${baseURL}/GetAllCaseUser?CaseId=${caseIDFromURL}`);
                const caseManagersData = response.data;

                if (caseManagersData.success) {
                    const enrichedCaseManagers = await Promise.all(caseManagersData.data.map(async (manager) => {
                        const fromUser = fetchUserDetails(manager.fromUserId);
                        const toUser = fetchUserDetails(manager.toUserId);
                        return {
                            ...manager,
                            fromUserName: fromUser ? `${fromUser.firstName} ${fromUser.lastName}` : "დაემატა სისტემურად",
                            toUserName: toUser ? `${toUser.firstName} ${toUser.lastName}` : ""
                        };
                    }));
                    setCaseManagers(enrichedCaseManagers.filter(manager => manager.caseUserType === null || manager.caseUserType === CaseUserStatus.CaseUser));
                }
            } catch (error) {
            } finally {
            }
        }
    };

    useEffect(() => {
        void fetchCaseManagersData();
    }, [roleId, users]);

    return (

        <div className="employee-form-wrapper">
            <h1 className="employee-form-title">შემსრულებლის შეცვლა/დამატება</h1>
            {caseData && caseManagers.length !== 0 && !hasExpertResult && roleId && departmentID && (
                <AddressingPopupAdmin
                    roleName={roleId}
                    onManagerAdded={refreshCaseManagers}
                    caseManagers={caseManagers}
                    caseDataDays={caseData.days}
                    departmentId={departmentID}
                />
            )}

            <table className="admin-case-user-edit-table">
                <thead>
                <tr>
                    <th style={{
                        textAlign: 'center', width: 20
                    }}><TiFlowSwitch/></th>
                    <th>დაამატა</th>
                    <th>მენეჯერი</th>
                    <th className="caseUser-icon-container">ქმედება</th>
                </tr>
                </thead>
                <tbody>

                {users.length > 0 && caseManagers.map((manager, index) => {
                    const firstArrowUpIndex = caseManagers.findIndex(manager => manager.status !== 0);
                    const backgroundColorClass = manager.isReturned
                        ? "admin-case-user-edit-bg-returned"
                        : (index === caseManagers.length - 1)
                            ? "admin-case-user-edit-bg-last"
                            : (index === firstArrowUpIndex - 1)
                                ? "admin-case-user-edit-bg-first-up"
                                : "";

                    return (
                        <tr key={manager.id}>
                            <td className={`admin-case-user-edit-arrow ${backgroundColorClass}`}>
                                {manager.status === 0 ? <FaArrowDown/> : <FaArrowUp/>}
                            </td>
                            <td className={`admin-case-user-edit-from-user ${backgroundColorClass}`}>
                                {!manager.addedBySystem ? manager.fromUserName : "დაემატა სისტემურად"}
                            </td>
                            <td className={`admin-case-user-edit-to-user ${backgroundColorClass}`}>
                                {manager.toUserName}
                            </td>
                            {index !== 0 && index !== 1 && index === caseManagers.length - 1 ? (
                                <td className="caseUser-icon-container">
                                    <Tooltip title={"შემსრულებლის წაშლა"}>
                                        <IoPersonRemoveSharp
                                            className="caseUser-icon caseUser-icon-remove"
                                            onClick={() => {
                                                setCaseUserDeleteModalOpen(true);
                                                setCurrentFileCaseUserId(manager)
                                            }}
                                        />
                                    </Tooltip>
                                    <Tooltip title={"შემსრულებლის შეცვლა"}>
                                        <AiOutlineUserSwitch
                                            className="caseUser-icon caseUser-icon-switch"
                                            onClick={() => {
                                                handleClickOpenCaseUserPopup()
                                                setManagerToEdit(manager);
                                            }}
                                        />
                                    </Tooltip>
                                </td>
                            ) : (
                                <td className="caseUser-icon-container">
                                </td>
                            )}

                        </tr>
                    );
                })}
                </tbody>
            </table>
            {caseUserDeleteModalOpen && (
                <ConfirmationModal
                    isOpen={caseUserDeleteModalOpen}
                    onRequestClose={() => setCaseUserDeleteModalOpen(false)}
                    onConfirm={handleDeleteCaseUser}
                />
            )}



            {users.length > 0 && managerToEdit && departmentID &&  (
                <ChangeCaseUserPopup
                    open={openChangeCaseUserPopup}
                    handleClose={handleCloseCaseUserPopup}
                    users={users}
                    caseManager={managerToEdit}
                    caseManagers={caseManagers}
                    onUpdate={fetchCaseManagersData}
                    caseFiles={caseFiles}
                    onFileUpdate={refreshCaseFiles}
                    departmentId={departmentID}

                />
            )}
        </div>
    );
};

export default AdminCaseUserEdit;


